import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {BroadcasterService} from '@core/broadcaster/broadcaster.service';

@Injectable()
export class UnauthorizedAPIEvent {
  constructor(private broadcaster: BroadcasterService) {}

  fire(): void {
    this.broadcaster.broadcast(UnauthorizedAPIEvent);
  }

  on(): Observable<any> {
    return this.broadcaster.on<any>(UnauthorizedAPIEvent);
  }
}



// WEBPACK FOOTER //
// D:/dclean-web-latest/cot-web/src/app/events/UnauthorizedAPIEvent.ts